<template>
    <div class="certificate-profile">
      <Header></Header>
      <sub-header :title="'صفحة التدريب'"></sub-header>
      <div class="certificate-info">
        <b-container>
          <div class="tab-container mb-4">
          <b-row>
            <b-col md="4" cols="12">
              <div class="certificate-picture">
                <img
                  v-if="training_programs.image"
                  :src="training_programs.image.url"
                  alt=""
                />
              </div>
            </b-col>
            <b-col md="8" cols="12">
              <ProgramDescription
                :programData="training_programs"
              ></ProgramDescription>
            </b-col>
          </b-row>
        </div>
          <b-row>
            <!-- <b-col md="12" cols="12">
              <div class="row ">
        <div class="sec-wrapper d-flex align-items-center mb-4">
          <h2 id="famous-companies " class="section-title"
          >
          الشهادة التي سوف تحصل  </h2>
          <div class="blue-line"></div>
        </div>
        <div
          v-for="certificate in training_programs.certificates"
          :key="certificate.id"
          class="col-md-3 col-12 mb-30"
        >
          <div class="mfbox ">
            <div class="mfbox__image">
              <router-link :to="`/cerificate/${certificate.id}`">

              <img v-if="certificate.file" :src="certificate.file.url" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col md="12" cols="12">
              <div class="row " v-if="training_programs.training_companies && training_programs.training_companies.length > 0">
        <div class="sec-wrapper d-flex align-items-center mb-4">
          <h2 id="famous-companies " class="section-title"
          >
          الجهات المقدمة للتدريب </h2>
          <div class="blue-line"></div>
        </div>
        <div
          v-for="company in training_programs.training_companies"
          :key="company.id"
          class="col-md-3 col-12 mb-30"
        >
          <div class="mfbox ">
            <div class="mfbox__image">
              <router-link :to="`/training-company/${company.id}`">

              <img v-if="company.image" :src="company.image.url" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <Footer></Footer>
    </div>
  </template>
  <script>
  import ProgramDescription from "@/components/TrainingProgram/ProgramDescription.vue";
  import Header from "@/components/Certificate/Header.vue";
  import Footer from "@/components/Home/Footer.vue";
  import axios from "axios";
  import SubHeader from '@/components/Certificate/SubHeader.vue';

  export default {
    name: "certificateShow",
    components: { Header, Footer , ProgramDescription, SubHeader },
    data() {
      return {
        tabIndex: 0,
        training_programs: {},
        searchQuery: null,
      };
    },
    async created() {
      // Fetch data from APIs
      await this.fetchtraining_programs();
    },
    watch: {
      searchQuery: {
        immediate: true,
      },
    },



    methods: {
      async fetchtraining_programs() {
        try {
            const response = await axios.get(
            `/training_programs/${this.$route.params.id}`
          );
          this.training_programs = response.data.data.training_program;
          console.log(this.training_programs)

        } catch (error) {
          console.error("Error fetching training_program data:", error);
        }
      },


    },
  };
  </script>
  <style lang="">
  </style>
